<!-- youtube-player.component.html -->
<div class="youtube-player-wrapper">
  
  <!-- Multiple videos mode -->
  <div *ngIf="videoInfos.length > 0" class="row">
    <ng-container *ngFor="let videoInfo of videoInfos; let i = index; trackBy: trackByFn">
      <div [ngClass]="videoInfos && videoInfos.length > 1 ? 'col-md-6' : 'col-md-12'" class="mb-4">

       <!-- Loader (shown while loading) -->
        <div *ngIf="loadingStates[i]" class="youtube-loader-minimal">
            <div class="loader-content">
                <div class="loader-spinner"></div>
            </div>
        </div>
        
        <!-- Player Container -->
        <div #playerContainer class="youtube-player-container" [class.hidden]="loadingStates[i]"></div>
        
        <!-- Fallback message -->
        <div *ngIf="loadingErrors[i] && showFallback" class="youtube-fallback">
          <div class="alert alert-warning mt-2">
            <p>Having trouble loading the video?</p>
            <a [href]="'https://youtube.com/watch?v=' + videoInfo.videoId" 
               target="_blank" 
               class="btn btn-sm btn-outline-primary">
              Watch on YouTube
            </a>
          </div>
        </div>
        
        <!-- Delete Button -->
        <div class="d-flex justify-content-end mt-2">
            <img
            src="/assets/icons/delete.svg"
            alt="delete-icon"
            height="20"
            width="20"
            (click)="onDeleteClick(i)"
            class="cursor-pointer"
            *ngIf="showDeleteButton"
            />
       </div>
        
      </div>
    </ng-container>
  </div>

  <div class="mt-3 quicksand-bold-label text-center" *ngIf="!videoInfos || videoInfos.length === 0">
      <img src="/assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" />
      <br />
      No Presentation Videos Found!
  </div>
</div>